import { TApplication } from '@helpers/GetTopUpStatus/getTopUpStatus.types';
import { fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TUseGetTopupPendingBannerData = {
    topUpAmount: number | null | undefined;
    isRepaymentReductionApplication: boolean;
};

export const useGetTopupPendingBannerData =
    (): TUseGetTopupPendingBannerData => {
        const stateKey = useStateKey();

        const { data: applicationResponse } = useQuery({
            queryKey: ['application', stateKey],
            queryFn: () =>
                fetchGetApplication({
                    stateKey
                }),
            suspense: true
        });
        if (!applicationResponse) {
            throw new Error();
        }

        return {
            topUpAmount: getApplicationRequestedAmount(
                applicationResponse.data
            ),
            isRepaymentReductionApplication:
                getApplicationRequestedCashAmount(applicationResponse.data) ===
                0
        };
    };

const getApplicationRequestedAmount = (application: TApplication) => {
    if (application?.status === 'open') {
        return application.requested_products?.[0].amount;
    }
    return null;
};

const getApplicationRequestedCashAmount = (application: TApplication) => {
    if (application?.status === 'open') {
        return application.requested_products?.[0].requested_cash_amount;
    }
    return null;
};
